<template>
    <select :disabled="readonly" v-model="displayValue" class="form-control" title="Tipo Pessoa">
        <option v-for="sn in onezero" :value="sn.value" v-bind:key="sn.value">{{ sn.name }}</option>
    </select>
</template>
<script>
export default {
    props: {
        value: {
            default: false
        },
        readonly: {
            default: false
        }
    },
    data() {
        return {
            onezero: [
                { name: "SIM", value: true },
                { name: "NÃO", value: false }
            ]
        };
    },
    computed: {
        displayValue: {
            get: function() {
                return this.value;
            },
            set: function(modifiedValue) {
                this.$emit("input", modifiedValue);
            }
        }
    }
};
</script>
